import { enrollApi } from 'yxt-biz-pc/packages/api';
/**
 * 员工报名详情
 */
export const getRecord = (recordId) => {
  return enrollApi.get(`/records/${recordId}/detail`);
};

/**
 * 员工报名审核
 */
export const checkRecords = (params) => {
  return enrollApi.put('/records/check', params);
};
